function Posts({ dimensions, col = '#000' }) {
  const baseXml = `
        <svg width=${dimensions || '20'} height=${dimensions || '20'} viewBox="0 0 27 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.49935 17.333H22.4993V15.333H4.49935V17.333ZM4.49935 11.9997H22.4993V9.99967H4.49935V11.9997ZM4.49935 6.66634H17.0993V4.66634H4.49935V6.66634ZM2.16602 21.6663C1.63268 21.6663 1.16602 21.4663 0.766016 21.0663C0.366016 20.6663 0.166016 20.1997 0.166016 19.6663V2.33301C0.166016 1.79967 0.366016 1.33301 0.766016 0.933008C1.16602 0.533008 1.63268 0.333008 2.16602 0.333008H24.8327C25.366 0.333008 25.8327 0.533008 26.2327 0.933008C26.6327 1.33301 26.8327 1.79967 26.8327 2.33301V19.6663C26.8327 20.1997 26.6327 20.6663 26.2327 21.0663C25.8327 21.4663 25.366 21.6663 24.8327 21.6663H2.16602ZM2.16602 19.6663H24.8327V2.33301H2.16602V19.6663Z" fill=${`"${col}"`}/>
        </svg>
    `;

  return baseXml;
}

export default Posts;
